import { getVerifiedDate } from "../shared-utils.js";
/**
 * Get Days in Month
 * @param {Date | number} date dateTime object or timestamp, defaults to now if not set
 * @returns {number} - the number of days in Date's month
 */
export const getDaysInMonth = (date) => {
    // verify date is good
    const newDate = getVerifiedDate(date);
    return new Date(newDate.getUTCFullYear(), newDate.getUTCMonth() + 1, 0).getUTCDate();
};
